import { z } from "zod";

export const KpiOverallSchema = z.object({
	avgResponseTime: z.number().nullable(),
	avgCompletionTime: z.number().nullable(),
	avgPathDeviation: z.number().nullable(),
	previousAvgResponseTime: z.number().nullable(),
	previousAvgCompletionTime: z.number().nullable(),
	previousAvgPathDeviation: z.number().nullable(),
	totalScenarios: z.number(),
	successCount: z.number(),
	failedCount: z.number(),
	previousFailedCount: z.number(),
	indeterminateCount: z.number(),
});

export const KpiPerScenarioSchema = z.object({
	courseId: z.number(),
	scenarioName: z.string(),
	avgResponseTime: z.number().nullable(),
	avgCompletionTime: z.number().nullable(),
	avgPathDeviation: z.number().nullable(),
	avgStagesTaken: z.number().nullable(),
	avgOptimalPathLength: z.number().nullable(),
	totalScenarios: z.number(),
	successCount: z.number(),
	failedCount: z.number(),
	indeterminateCount: z.number(),
});

export const KpiTrendSchema = z.object({
	date: z.string(),
	avgCompletionTime: z.number().nullable(),
	avgResponseTime: z.number().nullable(),
	count: z.number(),
	courseId: z.number().nullable(),
	courseName: z.string().nullable(),
	avgPathDeviation: z.number().nullable(),
	avgStagesTaken: z.number().nullable(),
	avgOptimalPathLength: z.number().nullable(),
	outcome: z.string().nullable(),
});

export const KpiDashboardResponseSchema = z.object({
	overall: KpiOverallSchema,
	perScenario: z.array(KpiPerScenarioSchema),
	trend: z.array(KpiTrendSchema),
});

export const KpiHasDataResponseSchema = z.object({
	hasData: z.boolean(),
});

export const KpiCourseSchema = z.object({
	courseId: z.number(),
	courseName: z.string(),
});
export type KpiCourse = z.infer<typeof KpiCourseSchema>;

export const KpiCoursesResponseSchema = z.array(KpiCourseSchema);
export type KpiCoursesResponse = z.infer<typeof KpiCoursesResponseSchema>;

export type KpiDashboardResponse = z.infer<typeof KpiDashboardResponseSchema>;
export type KpiOverall = z.infer<typeof KpiOverallSchema>;
export type KpiPerScenario = z.infer<typeof KpiPerScenarioSchema>;
export type KpiTrend = z.infer<typeof KpiTrendSchema>;
export type KpiHasDataResponse = z.infer<typeof KpiHasDataResponseSchema>;
